import { useCallback, useState } from "react";
import { Button, Flex, TextArea, Text } from "@radix-ui/themes";
import { Dialog } from "@/components/shared/dialog";

interface ImportFromCurlProps {
  onClose: () => void;
  onImport: (curl: string) => void;
}

export function ImportFromCurl({ onClose, onImport }: ImportFromCurlProps) {
  const [curl, setCurl] = useState("");

  const handleCurlChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setCurl(e.target.value);
    },
    []
  );

  const handleImport = useCallback(() => {
    onImport(curl);
  }, [curl, onImport]);

  return (
    <Dialog open onOpenChange={onClose}>
      <Dialog.Content className="p-4">
        <Flex direction="column" gap="4">
          <Text size="4" weight="bold">
            Import cURL
          </Text>

          <TextArea
            value={curl}
            onChange={handleCurlChange}
            placeholder="Paste your cURL command here"
            rows={10}
            variant="soft"
            color="gray"
            autoFocus
          />

          <Flex gap="2" justify="end">
            <Button variant="outline" color="gray" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="solid"
              color="gray"
              highContrast
              onClick={handleImport}
            >
              Import
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
}
